import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  card: {
    width: '22rem',
    marginBottom: '1.5rem',
    border: '1px solid #E6E6E5',
    borderRadius: '10px',
    boxShadow: '0 0',
    position: 'relative',
    paddingBottom: '3.5rem',
  },
});
